import React from "react"
import styled from "styled-components"
import { colors } from "buoy-theme"
import { ErrorMessage } from "buoy-core"
import { ToolTip } from "../../account/components/CardSubSection"
import { FormattedMessage } from "react-intl"

const selfHint = "Must be between 13 and 120"
const selfError = "You must be 13 or older to use Buoy"
const otherHint = "Must be between 2 and 120"
const selfTooltip = "Buoy Assistant is designed to consult on symptoms for patients between the ages of 13 and 120."
const otherTooltip = "Buoys Assistant is designed to consult on symptoms for patients between the ages of 2 and 120."

const HintTextContainer = styled.div`
  width: auto;
  text-align: right;
  margin-bottom: 10px;
`

const StyledTooltip = styled.div`
  display: inline-flex;
  margin-right: 10px;
`

const HintText = styled(ErrorMessage)`
  bottom: -1px;
  display: inline;
  margin: 4px 0 12px;
  color: ${props => props.error ? colors.error : colors.neutralDarkest};
`

const AgeInputHint = ({ pov, error, value }) => (
  <HintTextContainer>
    <StyledTooltip>
      <ToolTip
        message={
          pov === "self" ? (
            <FormattedMessage
              id="identifiers.age.tooltip"
              defaultMessage={selfTooltip}
            />
          ) : (
            <FormattedMessage
              id="identifiers.age.tooltip.other"
              defaultMessage={otherTooltip}
            />
          )
        }
      />
    </StyledTooltip>
    <HintText position="relative" width="100%" error={error}>
      {pov === "self" ? (
        // for self visits, swap hint text if user
        // attempts to submit age below 13
        error && value < 13 ? (
          selfError
        ) : (
          <FormattedMessage
            id="identifiers.age.alert"
            defaultMessage={selfHint}
          />
        )
      ) : (
        <FormattedMessage
          id="identifiers.age.alert.other"
          defaultMessage={otherHint}
        />
      )}
    </HintText>
  </HintTextContainer>
)

export { AgeInputHint as default }


// WEBPACK FOOTER //
// ./assets/identifiers/components/AgeInputHint.js